module.exports = __webpack_public_path__ + "static/img/role-es.d8addae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-1/role-es.png
// module id = w4ED
// module chunks = 1